export default __webpack_public_path__ + "static/media/cases4@2x.a4b07b0a.webp";